<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [hasDefault]="false"
  [columns]="columns"
  [noSubmit]="this.currentrow && this.currentrow.InvVoucherHeaderId"
  (cancelChange)="cancel()"
  (submitChange)="save()"
  [isShowModal]="false">
  <ng-container class="content" *ngIf="itemColumns && itemColumns.length > 0">
    <div class="d-flex gap">
      <ssg-select
        name="BranchId"
        [group]="formGroup"
        [dataList]="BranchLookUp"
        [label]="'ClientApp.FrontOffice.Inv.DailyHeader.Branch' | translate"
        textFieldName="Title"
        valueFieldName="Id"
        userClass="select-sm"
        [disabled]="this.currentrow && this.currentrow.InvVoucherHeaderId"
        (valueChange)="onBranchChanges($event)">
      </ssg-select>
      <date-picker
        id="VoucherDate"
        name="VoucherDate"
        [label]="'ClientApp.FrontOffice.Inv.DailyHeader.Date' | translate"
        [group]="formGroup"
        userClass="select-sm"
        required="false"
        textType="date"
        [disabled]="this.currentrow && this.currentrow.InvVoucherHeaderId">
      </date-picker>
      <ssg-input
        [group]="formGroup"
        userClass="desc"
        name="Description"
        textType="text"
        [label]="'ClientApp.FrontOffice.Inv.DailyHeader.Description' | translate"
        [disabled]="this.currentrow && this.currentrow.InvVoucherHeaderId"></ssg-input>

      <ssg-button
        *ngIf="model.Id && (model.Kind === invDailyKindEnum.ConfirmedBySima || model.Kind === invDailyKindEnum.Reject)"
        class="statebtn"
        [label]="'ClientApp.FrontOffice.Inv.DailyHeader.Confirm' | translate"
        (click)="confirm()">
      </ssg-button>
      <ssg-button
        *ngIf="model.Id && (model.Kind === invDailyKindEnum.ConfirmedBySima || model.Kind === invDailyKindEnum.Confirm)"
        class="statebtn"
        [label]="'ClientApp.FrontOffice.Inv.DailyHeader.Disapproval' | translate"
        (click)="reject()">
      </ssg-button>
    </div>

    <editable-grid
      #grid
      [columns]="itemColumns"
      [dataList]="model.InvDailyDetails"
      [isAdd]="!this.currentrow || !this.currentrow?.InvVoucherHeaderId"
      [isDelete]="!this.currentrow || !this.currentrow?.InvVoucherHeaderId"
      [RowNumberName]="'RowNumber'"
      (onRowSelected)="onRowSelected()"
      (afterDeleted)="afterDeleted()"
      [addRowAfterClickOutSideRow]="true"
      [filtering]="true"
      [paging]="true">
      <ssg-button
        *ngIf="!currentrow"
        id="toolbar-button"
        class="btnstyle"
        [tooltip]="'ClientApp.FrontOffice.Inv.DailyHeader.Upload' | translate"
        icon="icon-publish-o"
        (click)="ShowList()"></ssg-button>
      <ssg-button
        id="toolbar-button"
        class="btnstyle"
        (click)="removeEmptyValues()"
        [tooltip]="'ClientApp.FrontOffice.Inv.DailyHeader.RemoveItemsWithoutValue' | translate"
        icon="icon-delete-o"></ssg-button>
      <ssg-menu id="toolbar-button" icon="icon-print-o" class="btnstyle" tooltip="چاپ">
        <ng-container class="menuitem">
          <div>
            <div *ngFor="let report of reportKinds" class="reportbtn">
              <button class="btn" (click)="changeReport(report.value)">{{ report.name }}</button>
            </div>
          </div>
        </ng-container>
      </ssg-menu>
    </editable-grid>
  </ng-container>
</dynamic-form>
